var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5007 16.6667H19.1673V18.3333H0.833984V16.6667H2.50065V2.50001C2.50065 2.03977 2.87375 1.66667 3.33398 1.66667H16.6673C17.1276 1.66667 17.5007 2.03977 17.5007 2.50001V16.6667ZM15.834 16.6667V3.33334H4.16732V16.6667H15.834ZM6.66732 9.16667H9.16732V10.8333H6.66732V9.16667ZM6.66732 5.83334H9.16732V7.5H6.66732V5.83334ZM6.66732 12.5H9.16732V14.1667H6.66732V12.5ZM10.834 12.5H13.334V14.1667H10.834V12.5ZM10.834 9.16667H13.334V10.8333H10.834V9.16667ZM10.834 5.83334H13.334V7.5H10.834V5.83334Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcon);
export default __webpack_public_path__ + "static/media/addressIcon.b2f6a2e19661369f5f90091b8cc7e84b.svg";
export { ForwardRef as ReactComponent };